import { m, LazyMotion, domAnimation } from "framer-motion";
import LandingText from "../Components/landing/LandingText";
import LandingParticles from "../Components/particles/LandingParticles";
import LandingScroller from "../Components/landing/LandingScroller";

const Landing = () => {
  return (
    <div id="hero" className="w-full flex justify-center overflow-hidden-web relative">
    <LazyMotion features={domAnimation} strict>
      <m.div
        id="hero"
        className="relative w-full flex justify-center items-center h-screen min-h-[800px]"
      >
        <LandingText />
        <LandingParticles/>
      </m.div>
        <LandingScroller />
    </LazyMotion>
    </div>
  );
};

export default Landing;
